import React from 'react';
import PropTypes from 'prop-types';

import BlockComponent from './BlockComponent';
import blockDefinition from './definitions/media.json';

import ImageBlock from './Image';

const propTypes = {
    thumbnail: PropTypes.object,
    picture: PropTypes.object,
    document: PropTypes.object,
    showPicture: PropTypes.bool,
};

const defaultProps = {
    thumbnail: null,
    picture: null,
    document: null,
    showPicture: false,
};

class MediaBlock extends BlockComponent {

    render() {
        const {
            thumbnail,
            picture,
            document,
            showPicture,
            ...props
        } = this.props;

        const dataAttributes = {};
        if (picture !== null) {
            dataAttributes['data-pictures'] = picture.url;
        }
        if (document !== null) {
            dataAttributes['data-pdf'] = document.url;
        }

        return (
            <ImageBlock
                {...props}
                className="block-media"
                picture={showPicture ? picture : thumbnail}
                dataAttributes={dataAttributes}
            />
        );
    }
}

MediaBlock.propTypes = propTypes;
MediaBlock.defaultProps = defaultProps;
MediaBlock.blockDefinition = blockDefinition;

export default MediaBlock;



// WEBPACK FOOTER //
// ./components/blocks/Media.jsx